<div ngbAccordion class="m-0">
  @for (priceGroup of priceGroups; track priceGroup) {
    <div
      ngbAccordionItem
      cardClass="accordion-item--light-header nested-accordion"
    >
      <div ngbAccordionHeader>
        <button
          class="accordion-button"
          ngbAccordionButton
          aria-label="meer informatie"
          trackInteraction="click"
          interactionCategory="accordion"
          [interactionData]="{
            subject: priceGroup.description,
            name: priceGroup.description,
          }"
        >
          <ng-container
            *ngTemplateOutlet="
              header?.templateRef || defaultHeader;
              context: { $implicit: priceGroup }
            "
          ></ng-container>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            @for (price of priceGroup.prices; track price) {
              <div class="price-group-prices p-2">
                <ng-container
                  *ngTemplateOutlet="
                    content?.templateRef || defaultContent;
                    context: { $implicit: price }
                  "
                ></ng-container>
              </div>
            }
          </ng-template>
        </div>
      </div>
    </div>
  }
</div>

<ng-template #defaultHeader let-priceGroup>
  <div class="accordion-title">{{ priceGroup.description }}</div>
</ng-template>

<ng-template #defaultContent let-price>
  <div class="d-flex align-items-center justify-content-between">
    <p class="small m-0 w-75">
      {{ price.description }}
    </p>
    <p class="m-0 text-end">
      <strong>{{ price.unitPrice | currency: 'EUR' : '' : '1.2-5' }}</strong>
      {{ price.unit }}
    </p>
  </div>
</ng-template>
